import { getIdOrNull, requestWithPromise } from '..'
import { getDataOrDefault, HttpMethods } from '../apiHelper'

export const fetchInstitutionGroup = (user, institutionGroup) => {
  return requestWithPromise(
    `/api/institution-groups/${getIdOrNull(institutionGroup)}`,
    HttpMethods.GET,
    null,
    user
  ).then(getDataOrDefault())
}

export const updateInstitutionGroup = (user, institutionGroup) => {
  return requestWithPromise(
    `/api/institution-groups/${getIdOrNull(institutionGroup)}`,
    HttpMethods.PATCH,
    institutionGroup.toRequestBody(),
    user
  )
}

export const linkInstitionIntoInstitutionGroup = (user, institutionGroup, institution) => {
  return requestWithPromise(
    `/api/institution-groups/${getIdOrNull(institutionGroup)}/institutions`,
    HttpMethods.POST,
    { institution: getIdOrNull(institution) },
    user
  )
}

export const deleteInstitutionFromInstitutionGroup = (user, institutionGroup, institution) => {
  return requestWithPromise(
    `/api/institution-groups/${getIdOrNull(institutionGroup)}/institutions/${getIdOrNull(institution)}`,
    HttpMethods.DELETE,
    null,
    user
  )
}

export const linkSchoolToInstitutionGroup = (user, institutionGroup, school) => {
  return requestWithPromise(
    `/api/institution-groups/${getIdOrNull(institutionGroup)}/schools`,
    HttpMethods.POST,
    { school: getIdOrNull(school) },
    user
  )
}

export const unlinkSchoolFromInstitutionGroup = (user, institutionGroup, school) => {
  return requestWithPromise(
    `/api/institution-groups/${getIdOrNull(institutionGroup)}/schools/${getIdOrNull(school)}`,
    HttpMethods.DELETE,
    null,
    user
  )
}
